import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';

const Railing = styled(Flex)`
  overflow: hidden;
  height: 0.8rem;
  width: 100%;
  ${({ isRound }) => (isRound ? 'border-radius: 0.4rem;' : '')}
`;

const Progress = styled(Flex)`
  background-color: ${({ color, opacity = 1 }) =>
    `${getColor(color, opacity)}`};
  width: ${({ percent }) => `${percent}%`};
`;
const LinearProgressFiller = ({ parts = [], isRound = true, ...rest }) => (
  <Railing isRound={isRound} {...rest}>
    {parts.map((config, idx) => (
      <Progress {...config} key={`lp_${idx}`} />
    ))}
  </Railing>
);

export default LinearProgressFiller;
